import { render, staticRenderFns } from "./QctUserProtocal.vue?vue&type=template&id=3f3e407a&scoped=true&"
import script from "./QctUserProtocal.vue?vue&type=script&lang=js&"
export * from "./QctUserProtocal.vue?vue&type=script&lang=js&"
import style0 from "./QctUserProtocal.vue?vue&type=style&index=0&id=3f3e407a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3e407a",
  null
  
)

export default component.exports